import instObj from '@/backend/axios-instances'

const resource = "/productmaster"
const instance = instObj.baseInstance

export default {
  get(productId, parameters) {
    return instance.get(`${resource}/${productId}`, { params: parameters });
  },
  put(productId, data, parameters) {
    return instance.put(`${resource}/${productId}`, data, { params: parameters });
  },
  delete(productId) {
    return instance.delete(`${resource}/${productId}`);
  },
  addImage(productId, data) {
    return instance.post(`${resource}/${productId}/images`, data);
  }
}
